import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { IEmployeeReport } from '../interfaces/employee-report/iemployeereport';

@Injectable({
  providedIn: 'root'
})

export class EmployeeReportService {

  /* url: string = 'http://localhost:3000/employee_report'; */

  url: string = 'https://api-fake-r9p5.onrender.com/employee_report'; 
  

  constructor(private http: HttpClient) { }

  get() {
    return this.http
      .get(this.url)
      .pipe(map((res: any) => res)) as Observable<IEmployeeReport>;
    //.pipe(map((res: any) => res['hydra:member'])) as Observable<IEmployeeReport>;
  }
}
